export default __webpack_public_path__ + "pp-logo-mobile.a891da5e.svg";